import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export function useApiErrorHandler<T>() {
  const navigate = useNavigate();
  const [response, setResponse] = useState<T | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const fetchData = useCallback(async (func: Promise<T>) => {
    setLoading(true);
    try {
      const result = await func;
      setResponse(result);
      setError(null);
    }
    catch (error) {
      if (error instanceof Error && error.cause) {
        setError(error.message);
      }
      setResponse(null);
    }
    finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!loading && !error && !response) {
      navigate("/error");
    }
  }, [loading, error, response, navigate]);
  return { loading, error, response, fetchData };
}
